import { useEffect, useState } from "react";

export function usePortal({ elementId, replace = false }) {
  const [container, setContainer] = useState(null);

  useEffect(() => {
    const portalElement = document.getElementById(elementId);

    if (portalElement) {
      if (replace) {
        while (portalElement.firstChild) {
          portalElement.removeChild(portalElement.firstChild);
        }
      }
      setContainer(portalElement);
    }

    return () => {
      setContainer(null);
    };
  }, [elementId, replace]);

  return container;
}
